import { STATUS } from "@/lib/constants";

export const StatusBadge = ({ status, dark = false, testId }) => {
  const s = STATUS[status] || STATUS.assigned;
  return (
    <span data-testid={testId || `status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap ${dark ? s.dark : s.cls}`}>
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {s.label}
    </span>
  );
};
